import { apiSlice as api } from './index'
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCart: build.query<GetCartApiResponse, GetCartApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart`,
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        createCart: build.mutation<CreateCartApiResponse, CreateCartApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart`,
                method: 'POST',
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        deleteCart: build.mutation<DeleteCartApiResponse, DeleteCartApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart`,
                method: 'DELETE',
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        createCartItem: build.mutation<
            CreateCartItemApiResponse,
            CreateCartItemApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/item`,
                method: 'POST',
                body: queryArg.createCartItemCommand,
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        listCartItems: build.query<
            ListCartItemsApiResponse,
            ListCartItemsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/items`,
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        createCartItems: build.mutation<
            CreateCartItemsApiResponse,
            CreateCartItemsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/items`,
                method: 'POST',
                body: queryArg.createCartItemsCommand,
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        deleteCartItemsById: build.mutation<
            DeleteCartItemsByIdApiResponse,
            DeleteCartItemsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/items`,
                method: 'DELETE',
                body: queryArg.deleteCartItemsByIdCommand,
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        getCartItem: build.query<GetCartItemApiResponse, GetCartItemApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/item/${queryArg.cartItemId}`,
            }),
        }),
        deleteCartItemById: build.mutation<
            DeleteCartItemByIdApiResponse,
            DeleteCartItemByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/item/${queryArg.cartItemId}`,
                method: 'DELETE',
                headers: { Cookie: queryArg.cookie },
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        deleteCartPromotionCoupon: build.mutation<
            DeleteCartPromotionCouponApiResponse,
            DeleteCartPromotionCouponApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/promotion_coupon`,
                method: 'DELETE',
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        patchCartPromotionCoupon: build.mutation<
            PatchCartPromotionCouponApiResponse,
            PatchCartPromotionCouponApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/promotion_coupon`,
                method: 'PATCH',
                body: queryArg.addPromotionCouponCommand,
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        getCartItemAccommodation: build.query<
            GetCartItemAccommodationApiResponse,
            GetCartItemAccommodationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/details/accommodation/${queryArg.cartItemId}`,
                headers: { Cookie: queryArg.cookie },
            }),
        }),
        uploadCartItemCardImage: build.mutation<
            UploadCartItemCardImageApiResponse,
            UploadCartItemCardImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/item/card/image`,
                method: 'POST',
                body: queryArg.createCartItemImageCommand,
            }),
        }),
        getCartItemImage: build.query<
            GetCartItemImageApiResponse,
            GetCartItemImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/item/card/image/${queryArg.cartItemId}`,
            }),
        }),
        deleteCartItemImage: build.mutation<
            DeleteCartItemImageApiResponse,
            DeleteCartItemImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/item/card/image/${queryArg.cartItemId}`,
                method: 'DELETE',
            }),
        }),
        createBundleCartItems: build.mutation<
            CreateBundleCartItemsApiResponse,
            CreateBundleCartItemsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/bundle_cart_items`,
                method: 'POST',
                body: queryArg.createBundleCartItemsCommand,
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        patchCartGiftCard: build.mutation<
            PatchCartGiftCardApiResponse,
            PatchCartGiftCardApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/gift_card`,
                method: 'POST',
                body: queryArg.addGiftCardCommand,
                params: {
                    cartCreatorType: queryArg.cartCreatorType,
                    cartType: queryArg.cartType,
                },
            }),
        }),
        deleteCartGiftCard: build.mutation<
            DeleteCartGiftCardApiResponse,
            DeleteCartGiftCardApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/cart/gift_card`,
                method: 'DELETE',
                params: {
                    cartCreatorType: queryArg.cartCreatorType,
                    cartType: queryArg.cartType,
                },
            }),
        }),
        contactAdd: build.mutation<ContactAddApiResponse, ContactAddApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/contact`,
                method: 'POST',
                body: queryArg.createContactCommand,
            }),
        }),
        newsletterAdd: build.mutation<
            NewsletterAddApiResponse,
            NewsletterAddApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/newsletter`,
                method: 'POST',
                body: queryArg.createNewsletterCommand,
            }),
        }),
        getCreatorAccessibility: build.query<
            GetCreatorAccessibilityApiResponse,
            GetCreatorAccessibilityApiArg
        >({
            query: (queryArg) => ({ url: `/api/${queryArg._locale}/creator` }),
        }),
        listTicketPriceByTypes: build.query<
            ListTicketPriceByTypesApiResponse,
            ListTicketPriceByTypesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/tickets`,
                params: {
                    person: queryArg.person,
                    zone: queryArg.zone,
                    startDate: queryArg.startDate,
                    endDate: queryArg.endDate,
                },
            }),
        }),
        listTicketPersons: build.query<
            ListTicketPersonsApiResponse,
            ListTicketPersonsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/ticket/persons`,
            }),
        }),
        listTicketZonesByPerson: build.query<
            ListTicketZonesByPersonApiResponse,
            ListTicketZonesByPersonApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/ticket/${queryArg.person}/zones`,
                params: {
                    startDate: queryArg.startDate,
                    endDate: queryArg.endDate,
                },
            }),
        }),
        listTransportRouteTypes: build.query<
            ListTransportRouteTypesApiResponse,
            ListTransportRouteTypesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/transport/route-types`,
            }),
        }),
        listTransportDeparturePlaces: build.query<
            ListTransportDeparturePlacesApiResponse,
            ListTransportDeparturePlacesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/transport/departure-places`,
            }),
        }),
        getTransportSchedules: build.query<
            GetTransportSchedulesApiResponse,
            GetTransportSchedulesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/transport/schedules`,
                params: {
                    routeType: queryArg.routeType,
                    departurePlace: queryArg.departurePlace,
                    departureDate: queryArg.departureDate,
                    returnDate: queryArg.returnDate,
                },
            }),
        }),
        listCreatorCards: build.query<
            ListCreatorCardsApiResponse,
            ListCreatorCardsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/creator/cards`,
                params: {
                    person: queryArg.person,
                    cartCreatorType: queryArg.cartCreatorType,
                },
            }),
        }),
        listCreatorCardsBundle: build.query<
            ListCreatorCardsBundleApiResponse,
            ListCreatorCardsBundleApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/creator/cards/bundle`,
                params: {
                    person: queryArg.person,
                    cartCreatorType: queryArg.cartCreatorType,
                },
            }),
        }),
        listCreatorCardPersons: build.query<
            ListCreatorCardPersonsApiResponse,
            ListCreatorCardPersonsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/creator/card/persons`,
            }),
        }),
        getCreatorCabanaLimitByDate: build.query<
            GetCreatorCabanaLimitByDateApiResponse,
            GetCreatorCabanaLimitByDateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/creator/cabana/limit/${queryArg.date}`,
            }),
        }),
        listVouchers: build.query<ListVouchersApiResponse, ListVouchersApiArg>({
            query: (queryArg) => ({ url: `/api/${queryArg._locale}/vouchers` }),
        }),
        listCreatorSpaTreatments: build.query<
            ListCreatorSpaTreatmentsApiResponse,
            ListCreatorSpaTreatmentsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/spa-treatments`,
            }),
        }),
        getCreatorSpaTreatmentGroups: build.query<
            GetCreatorSpaTreatmentGroupsApiResponse,
            GetCreatorSpaTreatmentGroupsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/spa-treatments/${queryArg.spaTreatmentGroupId}`,
            }),
        }),
        listCreatorSpaTreatmentsAvailableHour: build.query<
            ListCreatorSpaTreatmentsAvailableHourApiResponse,
            ListCreatorSpaTreatmentsAvailableHourApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/spa-treatment-variants/${queryArg.productSpaTreatmentId}/available-hours`,
                params: { startDate: queryArg.startDate },
            }),
        }),
        createOrder: build.mutation<CreateOrderApiResponse, CreateOrderApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order`,
                method: 'POST',
                body: queryArg.createOrderCommand,
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        generateOrder: build.query<
            GenerateOrderApiResponse,
            GenerateOrderApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order/generate`,
                body: queryArg.generateOrderCommand,
            }),
        }),
        getOrderAnalitycs: build.query<
            GetOrderAnalitycsApiResponse,
            GetOrderAnalitycsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order/analitycs`,
                params: { orderId: queryArg.orderId },
            }),
        }),
        updateOrderCabanaUsedStatusGet: build.query<
            UpdateOrderCabanaUsedStatusGetApiResponse,
            UpdateOrderCabanaUsedStatusGetApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order/cabana/${queryArg.hksHardwareSerial}/used/${queryArg.isUsed}`,
            }),
        }),
        updateOrderCabanaUsedStatus: build.mutation<
            UpdateOrderCabanaUsedStatusApiResponse,
            UpdateOrderCabanaUsedStatusApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order/cabana/${queryArg.hksHardwareSerial}/used/${queryArg.isUsed}`,
                method: 'PATCH',
            }),
        }),
        listOpeningHours: build.query<
            ListOpeningHoursApiResponse,
            ListOpeningHoursApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/hours`,
                params: {
                    attractionKey: queryArg.attractionKey,
                    isDefault: queryArg.isDefault,
                },
            }),
        }),
        getProduct: build.query<GetProductApiResponse, GetProductApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/product`,
                params: { productType: queryArg.productType },
            }),
        }),
        listProducts: build.query<ListProductsApiResponse, ListProductsApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/products`,
                params: { productTypes: queryArg.productTypes },
            }),
        }),
        findTicketProductBundles: build.query<
            FindTicketProductBundlesApiResponse,
            FindTicketProductBundlesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/ticket_product_bundles`,
                params: {
                    cartType: queryArg.cartType,
                    startDate: queryArg.startDate,
                    endDate: queryArg.endDate,
                },
            }),
        }),
        accommodationSearchAvailableRooms: build.query<
            AccommodationSearchAvailableRoomsApiResponse,
            AccommodationSearchAvailableRoomsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/search`,
                params: {
                    startDate: queryArg.startDate,
                    endDate: queryArg.endDate,
                    adultCount: queryArg.adultCount,
                    childCount: queryArg.childCount,
                },
            }),
        }),
        accommodationGetHotels: build.query<
            AccommodationGetHotelsApiResponse,
            AccommodationGetHotelsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/hotels`,
            }),
        }),
        accommodationGetHotel: build.query<
            AccommodationGetHotelApiResponse,
            AccommodationGetHotelApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/hotel/${queryArg.hotelId}`,
            }),
        }),
        accommodationGetRooms: build.query<
            AccommodationGetRoomsApiResponse,
            AccommodationGetRoomsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/rooms`,
            }),
        }),
        accommodationGetRoom: build.query<
            AccommodationGetRoomApiResponse,
            AccommodationGetRoomApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/room/${queryArg.roomId}`,
            }),
        }),
        accommodationGetRoomsByHotelId: build.query<
            AccommodationGetRoomsByHotelIdApiResponse,
            AccommodationGetRoomsByHotelIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/rooms/hotel/${queryArg.hotelId}`,
            }),
        }),
        accommodationGetOccupancies: build.query<
            AccommodationGetOccupanciesApiResponse,
            AccommodationGetOccupanciesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/occupancies`,
            }),
        }),
        accommodationGetOccupancy: build.query<
            AccommodationGetOccupancyApiResponse,
            AccommodationGetOccupancyApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/occupancy/${queryArg.occupancyId}`,
            }),
        }),
        accommodationGetOccupanciesByRoomId: build.query<
            AccommodationGetOccupanciesByRoomIdApiResponse,
            AccommodationGetOccupanciesByRoomIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/occupancies/room/${queryArg.roomId}`,
            }),
        }),
        accommodationGetRates: build.query<
            AccommodationGetRatesApiResponse,
            AccommodationGetRatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/rates`,
            }),
        }),
        accommodationGetRate: build.query<
            AccommodationGetRateApiResponse,
            AccommodationGetRateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/rate/${queryArg.rateId}`,
            }),
        }),
        accommodationGetRatesByRoomId: build.query<
            AccommodationGetRatesByRoomIdApiResponse,
            AccommodationGetRatesByRoomIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/rates/room/${queryArg.roomId}`,
            }),
        }),
        accommodationGetReservation: build.query<
            AccommodationGetReservationApiResponse,
            AccommodationGetReservationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/reservation/${queryArg.reservationId}`,
            }),
        }),
        getPromotion: build.query<GetPromotionApiResponse, GetPromotionApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/promotion/${queryArg.promotionId}`,
            }),
        }),
        findPromotionByCouponCode: build.query<
            FindPromotionByCouponCodeApiResponse,
            FindPromotionByCouponCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/promotions/${queryArg.couponCode}`,
                params: { cartCreatorType: queryArg.cartCreatorType },
            }),
        }),
        guestLogin: build.mutation<GuestLoginApiResponse, GuestLoginApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare`,
                method: 'POST',
                body: queryArg.createSelfcareSessionCommand,
            }),
        }),
        listSelfcareOrderPositions: build.query<
            ListSelfcareOrderPositionsApiResponse,
            ListSelfcareOrderPositionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/positions`,
            }),
        }),
        deleteSelfcareOrderPositions: build.mutation<
            DeleteSelfcareOrderPositionsApiResponse,
            DeleteSelfcareOrderPositionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/order/positions`,
                method: 'DELETE',
            }),
        }),
        deleteSelfcareOrderPosition: build.mutation<
            DeleteSelfcareOrderPositionApiResponse,
            DeleteSelfcareOrderPositionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/position/delete`,
                method: 'POST',
                body: queryArg.deletePositionCommand,
            }),
        }),
        revertSelfcareOrderPosition: build.mutation<
            RevertSelfcareOrderPositionApiResponse,
            RevertSelfcareOrderPositionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/position/revert/${queryArg.modificationId}`,
                method: 'DELETE',
                body: queryArg.revertPositionCommand,
            }),
        }),
        editSelfcareOrderPosition: build.mutation<
            EditSelfcareOrderPositionApiResponse,
            EditSelfcareOrderPositionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/position/edit`,
                method: 'PUT',
                body: queryArg.editPositionCommand,
            }),
        }),
        revertChangeByProductType: build.mutation<
            RevertChangeByProductTypeApiResponse,
            RevertChangeByProductTypeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/revert/${queryArg.productType}`,
                method: 'DELETE',
                body: queryArg.revertByProductTypeCommand,
            }),
        }),
        revertChanges: build.mutation<
            RevertChangesApiResponse,
            RevertChangesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/revert`,
                method: 'DELETE',
            }),
        }),
        getSelfcareAttachment: build.query<
            GetSelfcareAttachmentApiResponse,
            GetSelfcareAttachmentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/attachment/${queryArg.orderAttachmentType}`,
            }),
        }),
        getSelfcareOrderPositionPrice: build.mutation<
            GetSelfcareOrderPositionPriceApiResponse,
            GetSelfcareOrderPositionPriceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/position/price`,
                method: 'POST',
                body: queryArg.selfcarePositionNewPriceQuery,
            }),
        }),
        getSelfcareCart: build.query<
            GetSelfcareCartApiResponse,
            GetSelfcareCartApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/cart`,
            }),
        }),
        createSelfcareCartItem: build.mutation<
            CreateSelfcareCartItemApiResponse,
            CreateSelfcareCartItemApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/cart/item`,
                method: 'POST',
                body: queryArg.createCartItemSelfcareCommand,
            }),
        }),
        deleteSelfcareCartItemById: build.mutation<
            DeleteSelfcareCartItemByIdApiResponse,
            DeleteSelfcareCartItemByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/cart/item/${queryArg.cartItemId}`,
                method: 'DELETE',
            }),
        }),
        deleteSelfcareCartItemsById: build.mutation<
            DeleteSelfcareCartItemsByIdApiResponse,
            DeleteSelfcareCartItemsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/cart/items`,
                method: 'DELETE',
                body: queryArg.deleteCartItemsByIdSelfcareCommand,
            }),
        }),
        createSelfcareOrder: build.mutation<
            CreateSelfcareOrderApiResponse,
            CreateSelfcareOrderApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/order`,
                method: 'POST',
                body: queryArg.createSelfcareOrderCommand,
            }),
        }),
        getShippingMethods: build.query<
            GetShippingMethodsApiResponse,
            GetShippingMethodsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/shipping/methods`,
                params: { codes: queryArg.codes },
            }),
        }),
        addShippingToCartPut: build.mutation<
            AddShippingToCartPutApiResponse,
            AddShippingToCartPutApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/shipping`,
                method: 'PUT',
                body: queryArg.addShippingToCartCommand,
            }),
        }),
        addShippingToCart: build.mutation<
            AddShippingToCartApiResponse,
            AddShippingToCartApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/shipping`,
                method: 'POST',
                body: queryArg.addShippingToCartCommand,
            }),
        }),
        deleteShippingToCart: build.mutation<
            DeleteShippingToCartApiResponse,
            DeleteShippingToCartApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/shipping`,
                method: 'DELETE',
                body: queryArg.deleteShippingFromCartCommand,
                headers: { Cookie: queryArg.cookie },
            }),
        }),
        getCalendarByProductType: build.query<
            GetCalendarByProductTypeApiResponse,
            GetCalendarByProductTypeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/calendar/${queryArg.productType}`,
            }),
        }),
        listTicketAvailableDays: build.query<
            ListTicketAvailableDaysApiResponse,
            ListTicketAvailableDaysApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/ticket/days`,
            }),
        }),
        listAccommodationAvailableDays: build.query<
            ListAccommodationAvailableDaysApiResponse,
            ListAccommodationAvailableDaysApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/accommodation/days`,
            }),
        }),
        getTransportAvailableDays: build.query<
            GetTransportAvailableDaysApiResponse,
            GetTransportAvailableDaysApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/transport/days`,
            }),
        }),
        getSelfcareCalendar: build.query<
            GetSelfcareCalendarApiResponse,
            GetSelfcareCalendarApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/selfcare/calendar`,
            }),
        }),
        getCardCalendar: build.query<
            GetCardCalendarApiResponse,
            GetCardCalendarApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/card/calendar`,
            }),
        }),
        listBanners: build.query<ListBannersApiResponse, ListBannersApiArg>({
            query: (queryArg) => ({ url: `/api/${queryArg._locale}/banners` }),
        }),
        homepageContent: build.query<
            HomepageContentApiResponse,
            HomepageContentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/homepage_content`,
            }),
        }),
        findRegulations: build.query<
            FindRegulationsApiResponse,
            FindRegulationsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/regulations`,
                params: {
                    sectionSlug: queryArg.sectionSlug,
                    productTypes: queryArg.productTypes,
                    cartCreatorTypes: queryArg.cartCreatorTypes,
                },
            }),
        }),
        findRegulationCategories: build.query<
            FindRegulationCategoriesApiResponse,
            FindRegulationCategoriesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/regulation_categories`,
            }),
        }),
        findRegulationSections: build.query<
            FindRegulationSectionsApiResponse,
            FindRegulationSectionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/regulation_sections`,
                params: { slugs: queryArg.slugs },
            }),
        }),
        findRegulationSectionBySlug: build.query<
            FindRegulationSectionBySlugApiResponse,
            FindRegulationSectionBySlugApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/regulation_sections/${queryArg.slug}`,
            }),
        }),
        getFindRegulationDocumentById: build.query<
            GetFindRegulationDocumentByIdApiResponse,
            GetFindRegulationDocumentByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/regulation_documents/${queryArg.regulationDocumentId}`,
            }),
        }),
        listUserOrder: build.query<
            ListUserOrderApiResponse,
            ListUserOrderApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/user/orders`,
            }),
        }),
        getUserOrder: build.query<GetUserOrderApiResponse, GetUserOrderApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/user/orders/${queryArg.orderId}`,
            }),
        }),
        createOrderCardRenewSession: build.mutation<
            CreateOrderCardRenewSessionApiResponse,
            CreateOrderCardRenewSessionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order_card_renew_sessions`,
                method: 'POST',
                body: queryArg.createOrderCardRenewSessionCommand,
            }),
        }),
        getOrderCardRenewToken: build.query<
            GetOrderCardRenewTokenApiResponse,
            GetOrderCardRenewTokenApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/order_card_renew_tokens/${queryArg.orderCardRenewTokenId}`,
            }),
        }),
        getCurrentOrderCard: build.query<
            GetCurrentOrderCardApiResponse,
            GetCurrentOrderCardApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/current_order_card`,
            }),
        }),
        postNotification: build.mutation<
            PostNotificationApiResponse,
            PostNotificationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/payment/notification`,
                method: 'POST',
            }),
        }),
        postNotificationMoyome: build.mutation<
            PostNotificationMoyomeApiResponse,
            PostNotificationMoyomeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/payment/notification/accommodation`,
                method: 'POST',
            }),
        }),
        findPaymentById: build.query<
            FindPaymentByIdApiResponse,
            FindPaymentByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/payments/${queryArg.paymentId}`,
            }),
        }),
        getVoucher: build.query<GetVoucherApiResponse, GetVoucherApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/voucher/${queryArg.number}`,
            }),
        }),
        getTraffic: build.query<GetTrafficApiResponse, GetTrafficApiArg>({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/traffic_indicator`,
            }),
        }),
        getDeprecatedUserRegisterConfirm: build.query<
            GetDeprecatedUserRegisterConfirmApiResponse,
            GetDeprecatedUserRegisterConfirmApiArg
        >({
            query: (queryArg) => ({
                url: `/api/${queryArg._locale}/user/register/confirm/${queryArg.token}`,
                params: { lang: queryArg.lang },
            }),
        }),
        getHealthCheckRedis: build.query<
            GetHealthCheckRedisApiResponse,
            GetHealthCheckRedisApiArg
        >({
            query: () => ({ url: '/api/healthcheck/redis' }),
        }),
        getHealthCheckDatabase: build.query<
            GetHealthCheckDatabaseApiResponse,
            GetHealthCheckDatabaseApiArg
        >({
            query: () => ({ url: '/api/healthcheck/database' }),
        }),
        getHealthCheckReadiness: build.query<
            GetHealthCheckReadinessApiResponse,
            GetHealthCheckReadinessApiArg
        >({
            query: () => ({ url: '/api/healthcheck/readiness' }),
        }),
        getHealthCheckLiveness: build.query<
            GetHealthCheckLivenessApiResponse,
            GetHealthCheckLivenessApiArg
        >({
            query: () => ({ url: '/api/healthcheck/liveness' }),
        }),
        pushMessage: build.query<PushMessageApiResponse, PushMessageApiArg>({
            query: () => ({ url: '/api/push' }),
        }),
    }),
    overrideExisting: false,
})
export { injectedRtkApi as apiSlice }
export type GetCartApiResponse = /** status 200 Success */ GetCartPresenter
export type GetCartApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cookie?: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type CreateCartApiResponse =
    /** status 201 Created */ CreateCartIdPresenter
export type CreateCartApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type DeleteCartApiResponse = unknown
export type DeleteCartApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cookie?: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type CreateCartItemApiResponse = /** status 201 Created */ void
export type CreateCartItemApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    cookie?: string
    createCartItemCommand: CreateCartItemCommand
}
export type ListCartItemsApiResponse =
    /** status 200 Success */ ListCartItemsPresenter
export type ListCartItemsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cookie?: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type CreateCartItemsApiResponse = /** status 201 Created */ void
export type CreateCartItemsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cookie?: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    createCartItemsCommand: CreateCartItemsCommand
}
export type DeleteCartItemsByIdApiResponse = unknown
export type DeleteCartItemsByIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cookie?: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    deleteCartItemsByIdCommand: DeleteCartItemsByIdCommand
}
export type GetCartItemApiResponse =
    /** status 200 Success */ GetCartItemPresenter
export type GetCartItemApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    cartItemId: string
}
export type DeleteCartItemByIdApiResponse = unknown
export type DeleteCartItemByIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartItemId: string
    cookie?: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type DeleteCartPromotionCouponApiResponse = unknown
export type DeleteCartPromotionCouponApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type PatchCartPromotionCouponApiResponse = unknown
export type PatchCartPromotionCouponApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    addPromotionCouponCommand: AddPromotionCouponCommand
}
export type GetCartItemAccommodationApiResponse =
    /** status 200 Success */ ListAccommodationItemPresenter
export type GetCartItemAccommodationApiArg = {
    _locale: string
    cartItemId: string
    cookie?: string
}
export type UploadCartItemCardImageApiResponse = unknown
export type UploadCartItemCardImageApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    createCartItemImageCommand: CreateCartItemImageCommand
}
export type GetCartItemImageApiResponse = unknown
export type GetCartItemImageApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartItemId: string
}
export type DeleteCartItemImageApiResponse = unknown
export type DeleteCartItemImageApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartItemId: string
}
export type CreateBundleCartItemsApiResponse = unknown
export type CreateBundleCartItemsApiArg = {
    _locale: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    createBundleCartItemsCommand: CreateBundleCartItemsCommand
}
export type PatchCartGiftCardApiResponse = unknown
export type PatchCartGiftCardApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    cartType: 'selfcare' | 'creator'
    addGiftCardCommand: AddGiftCardCommand
}
export type DeleteCartGiftCardApiResponse = unknown
export type DeleteCartGiftCardApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    cartType: 'selfcare' | 'creator'
}
export type ContactAddApiResponse = unknown
export type ContactAddApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    createContactCommand: CreateContactCommand
}
export type NewsletterAddApiResponse = unknown
export type NewsletterAddApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    createNewsletterCommand: CreateNewsletterCommand
}
export type GetCreatorAccessibilityApiResponse =
    /** status 200 Creator accessibility */ ReadPresenter
export type GetCreatorAccessibilityApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type ListTicketPriceByTypesApiResponse =
    /** status 200 List of tickets */ ListTicketPresenter
export type ListTicketPriceByTypesApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    person:
        | 'teen_reduced'
        | 'kid_to_120_cm'
        | 'teenager'
        | 'pregnant'
        | 'kid_to_90_cm'
        | 'senior'
        | 'disabled'
        | 'adult'
    zone?: ('jamango' | 'relax' | 'saunaria') | null
    startDate: string
    endDate?: string
}
export type ListTicketPersonsApiResponse =
    /** status 200 Get persons */ ListPresenter
export type ListTicketPersonsApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type ListTicketZonesByPersonApiResponse =
    /** status 200 Get zone */ ListZonePresenter
export type ListTicketZonesByPersonApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    person:
        | 'teen_reduced'
        | 'kid_to_120_cm'
        | 'teenager'
        | 'pregnant'
        | 'kid_to_90_cm'
        | 'senior'
        | 'disabled'
        | 'adult'
    startDate?: string
    endDate?: string
}
export type ListTransportRouteTypesApiResponse =
    /** status 200 Route types */ ListPresenter2
export type ListTransportRouteTypesApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type ListTransportDeparturePlacesApiResponse =
    /** status 200 Departure places */ ListPresenter3
export type ListTransportDeparturePlacesApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type GetTransportSchedulesApiResponse =
    /** status 200 Available transport schedules */ BusSchedulePresenter
export type GetTransportSchedulesApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    routeType: 'to_from_park' | 'to_park' | 'from_park'
    departurePlace: 'warsaw' | 'zyrardow'
    departureDate: string
    returnDate?: string
}
export type ListCreatorCardsApiResponse =
    /** status 200 List of cards */ ListCardPresenter
export type ListCreatorCardsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    person: 'teen_reduced' | 'adult' | 'kid_to_120_cm' | 'discounted'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type ListCreatorCardsBundleApiResponse =
    /** status 200 List of bundle cards */ ListCardBundlePresenter
export type ListCreatorCardsBundleApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    person: 'teen_reduced' | 'adult' | 'kid_to_120_cm' | 'discounted'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type ListCreatorCardPersonsApiResponse =
    /** status 200 Get card persons */ ListCardPersonPresenter
export type ListCreatorCardPersonsApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type GetCreatorCabanaLimitByDateApiResponse =
    /** status 200 Limit by day */ GetCabanaLimitByDatePresenter
export type GetCreatorCabanaLimitByDateApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    date: string
}
export type ListVouchersApiResponse =
    /** status 200 List product vouchers */ ProductVouchersPresenter
export type ListVouchersApiArg = {
    _locale: string
}
export type ListCreatorSpaTreatmentsApiResponse =
    /** status 200 List of spa treatments */ ListSpaTreatmentPresenter
export type ListCreatorSpaTreatmentsApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type GetCreatorSpaTreatmentGroupsApiResponse =
    /** status 200 Spa Treatment */ GetSpaTreatmentPresenter
export type GetCreatorSpaTreatmentGroupsApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    spaTreatmentGroupId: string
}
export type ListCreatorSpaTreatmentsAvailableHourApiResponse =
    /** status 200 List of spa treatments */ ListSpaTreatmentAvailableHourPresenter
export type ListCreatorSpaTreatmentsAvailableHourApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    startDate: string
    productSpaTreatmentId: string
}
export type CreateOrderApiResponse =
    /** status 200 Created order data */ CreateOrderPresenter
export type CreateOrderApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    createOrderCommand: CreateOrderCommand
}
export type GenerateOrderApiResponse = unknown
export type GenerateOrderApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    generateOrderCommand: GenerateOrderCommand
}
export type GetOrderAnalitycsApiResponse =
    /** status 200 Success */ GetOrderAnalitycsPresenter
export type GetOrderAnalitycsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    orderId: string
}
export type UpdateOrderCabanaUsedStatusGetApiResponse = unknown
export type UpdateOrderCabanaUsedStatusGetApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    hksHardwareSerial: string
    isUsed: string
}
export type UpdateOrderCabanaUsedStatusApiResponse = unknown
export type UpdateOrderCabanaUsedStatusApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    hksHardwareSerial: string
    isUsed: string
}
export type ListOpeningHoursApiResponse =
    /** status 200 List available opening hours */ ListOpeningHoursItemsPresenter
export type ListOpeningHoursApiArg = {
    _locale: string
    attractionKey?: string
    isDefault?: boolean
}
export type GetProductApiResponse =
    /** status 200 Success */ GetProductPresenter
export type GetProductApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    productType:
        | 'ticket'
        | 'voucher'
        | 'product_voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'accommodation'
        | 'shipping'
        | 'handling_fee'
        | 'card'
        | 'parking'
        | 'bundle'
        | 'restaurant_service'
        | 'spa_treatment'
}
export type ListProductsApiResponse =
    /** status 200 List products */ ListProductPresenter
export type ListProductsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    productTypes: (
        | 'ticket'
        | 'voucher'
        | 'product_voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'accommodation'
        | 'shipping'
        | 'handling_fee'
        | 'card'
        | 'parking'
        | 'bundle'
        | 'restaurant_service'
        | 'spa_treatment'
    )[]
}
export type FindTicketProductBundlesApiResponse =
    /** status 200 List ticket product bundles */ ProductBundlesPresenter
export type FindTicketProductBundlesApiArg = {
    _locale: string
    cartType: string
    startDate?: string
    endDate?: string
}
export type AccommodationSearchAvailableRoomsApiResponse =
    /** status 200 Success */ SearchRoomsPresenter
export type AccommodationSearchAvailableRoomsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    startDate: string
    endDate: string
    adultCount: number
    childCount: number
}
export type AccommodationGetHotelsApiResponse =
    /** status 200 Success */ ListHotelsPresenter
export type AccommodationGetHotelsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type AccommodationGetHotelApiResponse =
    /** status 200 Success */ GetHotelPresenter
export type AccommodationGetHotelApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    hotelId: string
}
export type AccommodationGetRoomsApiResponse =
    /** status 200 Success */ ListRoomsPresenter
export type AccommodationGetRoomsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type AccommodationGetRoomApiResponse =
    /** status 200 Success */ GetRoomPresenter
export type AccommodationGetRoomApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    roomId: string
}
export type AccommodationGetRoomsByHotelIdApiResponse =
    /** status 200 Success */ ListRoomsPresenter
export type AccommodationGetRoomsByHotelIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    hotelId: string
}
export type AccommodationGetOccupanciesApiResponse =
    /** status 200 Success */ ListOccupanciesPresenter
export type AccommodationGetOccupanciesApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type AccommodationGetOccupancyApiResponse =
    /** status 200 Success */ GetOccupancyPresenter
export type AccommodationGetOccupancyApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    occupancyId: string
}
export type AccommodationGetOccupanciesByRoomIdApiResponse =
    /** status 200 Success */ ListOccupanciesByRoomPresenter
export type AccommodationGetOccupanciesByRoomIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    roomId: string
}
export type AccommodationGetRatesApiResponse =
    /** status 200 Success */ ListRatesPresenter
export type AccommodationGetRatesApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type AccommodationGetRateApiResponse =
    /** status 200 Success */ GetRatePresenter
export type AccommodationGetRateApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    rateId: string
}
export type AccommodationGetRatesByRoomIdApiResponse =
    /** status 200 Success */ ListRatesByRoomPresenter
export type AccommodationGetRatesByRoomIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    roomId: string
}
export type AccommodationGetReservationApiResponse =
    /** status 200 Success */ GetReservationPresenter
export type AccommodationGetReservationApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    reservationId: string
}
export type GetPromotionApiResponse =
    /** status 200 Promotion */ GetPromotionPresenter
export type GetPromotionApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    promotionId: string
}
export type FindPromotionByCouponCodeApiResponse =
    /** status 200 Promotion */ PromotionPresenter
export type FindPromotionByCouponCodeApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    couponCode: string
    cartCreatorType:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
}
export type GuestLoginApiResponse = unknown
export type GuestLoginApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    createSelfcareSessionCommand: CreateSelfcareSessionCommand
}
export type ListSelfcareOrderPositionsApiResponse =
    /** status 200 Fetch information about reservation while editing */ ListSelfcarePositionsPresenter
export type ListSelfcareOrderPositionsApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type DeleteSelfcareOrderPositionsApiResponse = unknown
export type DeleteSelfcareOrderPositionsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type DeleteSelfcareOrderPositionApiResponse = unknown
export type DeleteSelfcareOrderPositionApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    deletePositionCommand: DeletePositionCommand
}
export type RevertSelfcareOrderPositionApiResponse = unknown
export type RevertSelfcareOrderPositionApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    modificationId: string
    revertPositionCommand: RevertPositionCommand
}
export type EditSelfcareOrderPositionApiResponse = unknown
export type EditSelfcareOrderPositionApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    editPositionCommand: EditPositionCommand
}
export type RevertChangeByProductTypeApiResponse = unknown
export type RevertChangeByProductTypeApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    productType: string
    revertByProductTypeCommand: RevertByProductTypeCommand
}
export type RevertChangesApiResponse = unknown
export type RevertChangesApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type GetSelfcareAttachmentApiResponse = unknown
export type GetSelfcareAttachmentApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    orderAttachmentType:
        | 'ticket'
        | 'transport_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'bundle'
}
export type GetSelfcareOrderPositionPriceApiResponse =
    /** status 200 Fetch information about new price */ SelfcarePositionNewPricePresenter
export type GetSelfcareOrderPositionPriceApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    selfcarePositionNewPriceQuery: SelfcarePositionNewPriceQuery
}
export type GetSelfcareCartApiResponse =
    /** status 200 Success */ GetCartSelfcarePresenter
export type GetSelfcareCartApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type CreateSelfcareCartItemApiResponse = unknown
export type CreateSelfcareCartItemApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    createCartItemSelfcareCommand: CreateCartItemSelfcareCommand
}
export type DeleteSelfcareCartItemByIdApiResponse = unknown
export type DeleteSelfcareCartItemByIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cartItemId: string
}
export type DeleteSelfcareCartItemsByIdApiResponse = unknown
export type DeleteSelfcareCartItemsByIdApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    deleteCartItemsByIdSelfcareCommand: DeleteCartItemsByIdSelfcareCommand
}
export type CreateSelfcareOrderApiResponse =
    /** status 200 Created selfcare order data */ CreateOrderPresenter
export type CreateSelfcareOrderApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    createSelfcareOrderCommand: CreateSelfcareOrderCommand
}
export type GetShippingMethodsApiResponse =
    /** status 200 Success */ GetShippingMethodsPresenter
export type GetShippingMethodsApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    codes?: ('email' | 'self_pickup' | 'inpost_delivery_address')[]
}
export type AddShippingToCartPutApiResponse = unknown
export type AddShippingToCartPutApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    addShippingToCartCommand: AddShippingToCartCommand
}
export type AddShippingToCartApiResponse = unknown
export type AddShippingToCartApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    addShippingToCartCommand: AddShippingToCartCommand
}
export type DeleteShippingToCartApiResponse = unknown
export type DeleteShippingToCartApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    cookie?: string
    deleteShippingFromCartCommand: DeleteShippingFromCartCommand
}
export type GetCalendarByProductTypeApiResponse =
    /** status 200 Success */ GetCalendarPresenter
export type GetCalendarByProductTypeApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    productType: 'cabana' | 'spa_treatment'
}
export type ListTicketAvailableDaysApiResponse =
    /** status 200 Get available days to buy a ticket */ ReadPresenter2
export type ListTicketAvailableDaysApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type ListAccommodationAvailableDaysApiResponse =
    /** status 200 Get available days to reserve an accommodation */ ReadPresenter3
export type ListAccommodationAvailableDaysApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type GetTransportAvailableDaysApiResponse =
    /** status 200 Available days to reserve an transport ticket */ ReadPresenter4
export type GetTransportAvailableDaysApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type GetSelfcareCalendarApiResponse =
    /** status 200 Get calendar for selfcare */ GetCalendarPresenter2
export type GetSelfcareCalendarApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type GetCardCalendarApiResponse =
    /** status 200 Success */ GetCardCalendarPresenter
export type GetCardCalendarApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type ListBannersApiResponse =
    /** status 200 List banners */ ListBannerQueryPresenter
export type ListBannersApiArg = {
    _locale: string
}
export type HomepageContentApiResponse =
    /** status 200 Get homepage content */ HomepageContentPresenter
export type HomepageContentApiArg = {
    _locale: string
}
export type FindRegulationsApiResponse =
    /** status 200 List regulations */ RegulationsPresenter
export type FindRegulationsApiArg = {
    _locale: string
    sectionSlug?: string
    productTypes?: {
        ''?: string[]
    }
    cartCreatorTypes?: {
        ''?: string[]
    }
}
export type FindRegulationCategoriesApiResponse =
    /** status 200 List regulation categories */ RegulationCategoriesPresenter
export type FindRegulationCategoriesApiArg = {
    _locale: string
}
export type FindRegulationSectionsApiResponse = unknown
export type FindRegulationSectionsApiArg = {
    _locale: string
    slugs?: {
        ''?: string[]
    }
}
export type FindRegulationSectionBySlugApiResponse =
    /** status 200 Regulation Section */ RegulationSectionPresenter
export type FindRegulationSectionBySlugApiArg = {
    _locale: string
    slug?: string
}
export type GetFindRegulationDocumentByIdApiResponse = unknown
export type GetFindRegulationDocumentByIdApiArg = {
    regulationDocumentId: string
    _locale: 'pl' | 'en' | 'uk'
}
export type ListUserOrderApiResponse =
    /** status 200 List user orders */ ListOrderPresenter
export type ListUserOrderApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type GetUserOrderApiResponse =
    /** status 200 List user orders */ GetOrderItemPresenter
export type GetUserOrderApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    orderId: string
}
export type CreateOrderCardRenewSessionApiResponse = unknown
export type CreateOrderCardRenewSessionApiArg = {
    _locale: 'pl' | 'en' | 'uk'
    createOrderCardRenewSessionCommand: CreateOrderCardRenewSessionCommand
}
export type GetOrderCardRenewTokenApiResponse =
    /** status 200 Get order card renew token by id */ GetOrderCardRenewTokenPresenter
export type GetOrderCardRenewTokenApiArg = {
    _locale: string
    orderCardRenewTokenId: string
}
export type GetCurrentOrderCardApiResponse =
    /** status 200 Get order card owner details */ GetCurrentOrderCardPresenter
export type GetCurrentOrderCardApiArg = {
    _locale: string
}
export type PostNotificationApiResponse = unknown
export type PostNotificationApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type PostNotificationMoyomeApiResponse = unknown
export type PostNotificationMoyomeApiArg = {
    _locale: 'pl' | 'en' | 'uk'
}
export type FindPaymentByIdApiResponse =
    /** status 200 Get payment */ PaymentPresenter
export type FindPaymentByIdApiArg = {
    _locale: string
    paymentId: string
}
export type GetVoucherApiResponse =
    /** status 200 Success */ GetVoucherQueryPresenter
export type GetVoucherApiArg = {
    _locale: 'en' | 'pl' | 'uk'
    number: string
}
export type GetTrafficApiResponse =
    /** status 200 Traffic indicator */ GetTrafficIndicatorPresenter
export type GetTrafficApiArg = {
    _locale: 'en' | 'pl' | 'uk'
}
export type GetDeprecatedUserRegisterConfirmApiResponse = unknown
export type GetDeprecatedUserRegisterConfirmApiArg = {
    token: string
    lang?: string
    _locale: 'pl' | 'en' | 'uk'
}
export type GetHealthCheckRedisApiResponse = unknown
export type GetHealthCheckRedisApiArg = void
export type GetHealthCheckDatabaseApiResponse = unknown
export type GetHealthCheckDatabaseApiArg = void
export type GetHealthCheckReadinessApiResponse = unknown
export type GetHealthCheckReadinessApiArg = void
export type GetHealthCheckLivenessApiResponse = unknown
export type GetHealthCheckLivenessApiArg = void
export type PushMessageApiResponse = unknown
export type PushMessageApiArg = void
export type CartTranslation = {
    locale?: string
    name?: string
    description?: string
}
export type CartItemTicketDetailDto = {
    date: string
    zone: 'jamango' | 'relax' | 'saunaria'
    person:
        | 'teen_reduced'
        | 'kid_to_120_cm'
        | 'teenager'
        | 'pregnant'
        | 'kid_to_90_cm'
        | 'senior'
        | 'disabled'
        | 'adult'
    ticketTime: '2h' | '4h' | 'day'
    boxId: string
}
export type CartItemTransportTicketDetailDto = {
    time?: string | null
    returnDate: string | null
    returnTime?: string | null
    isRequiresPurchaseTimeSlot?: boolean
    routeType: 'to_from_park' | 'to_park' | 'from_park'
    departurePlace: 'warsaw' | 'zyrardow'
    date: string
    boxId: string
    isShuttle: boolean
}
export type GuestDto = {
    firstName?: string
    lastName?: string
    boxId?: string
    personType?: string
}
export type SpecialRequestsDto = {
    guests?: GuestDto[]
    request?: string
}
export type CreateReservationRoomDto = {
    roomId: string
    rateId: string
    occupancyId: string
    quantity: number
    roomName?: string
    rateName?: string
}
export type CartItemAccommodationDetailDto = {
    specialRequests?: SpecialRequestsDto | null
    rooms?: CreateReservationRoomDto[]
    dateFrom: string
    dateTo: string
    adultCount: number
    childCount: number
    customerFirstName: string
    customerLastName: string
    customerEmail: string
    customerPhone: string
}
export type CartItemCardDetailDto = {
    rootOrderCardId?: string
    firstName: string
    lastName: string
    dateOfBirth: string
    email: string
    phone: string
    person: 'teen_reduced' | 'adult' | 'kid_to_120_cm' | 'discounted'
    cardType:
        | 'unlimited'
        | 'unlimited_bundle'
        | 'unlimited_plus'
        | 'unlimited_plus_bundle'
}
export type CartItemVoucherAmountDetailDto = {
    voucherType?: 'amount'
    voucherSignature: string[]
    amount: number
    productType?: string
}
export type CartItemVoucherProductDetailDto = {
    voucherType?: 'product'
    voucherSignature: string[]
    productType?: string
}
export type CartItemSpaTreatmentDetailDto = {
    startDate: string
    endDate: string
    variant: number
}
export type CartItemVoucherNextVisitDetailDto = {
    productType?: string
    voucherType?: 'next-visit'
    cartItemId: string
    name?: string
    surname?: string
}
export type GetCartItemPresenter = {
    totalPriceWithoutDiscount?: number | null
    itemsBundle?: GetCartItemPresenter[]
    translations?: CartTranslation[]
    cartItemId?: string
    cartItemBundleId?: string
    name?: string
    productType?:
        | 'ticket'
        | 'voucher'
        | 'product_voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'accommodation'
        | 'shipping'
        | 'handling_fee'
        | 'card'
        | 'parking'
        | 'bundle'
        | 'restaurant_service'
        | 'spa_treatment'
    productId?: string
    description?: string
    quantity?: number
    unitPrice?: number
    totalPrice?: number
    vat?: number
    lowestPriceLast30Days?: number | null
    hasPromotion?: boolean
    detail?:
        | CartItemTicketDetailDto
        | CartItemTransportTicketDetailDto
        | CartItemAccommodationDetailDto
        | CartItemCardDetailDto
        | CartItemVoucherAmountDetailDto
        | CartItemVoucherProductDetailDto
        | CartItemSpaTreatmentDetailDto
        | CartItemVoucherNextVisitDetailDto
}
export type GiftCardDto = {
    number?: string
    value?: number
}
export type RegulationPresenter = {
    name?: string
    url?: string
}
export type GetCartRegulationsPresenter = {
    promotions?: RegulationPresenter[]
    products?: RegulationPresenter[]
}
export type CartPromotionPresenter = {
    promotionId?: string
}
export type CartSummaryDto = {
    youSave?: number
    beforeDiscountPrice?: number | null
    cartId?: string
    totalPrice?: number
    payOnlinePrice?: number
    payOnSpotPrice?: number
    payByCardPrice?: number
    remainingCardValue?: number
    adjustmentPrice?: number
    refundPrice?: number
    status?: string
    items?: GetCartItemPresenter[]
    giftCards?: GiftCardDto[]
    promotionCouponCode?: string
    couponSimulationPrice?: number | null
    regulations?: GetCartRegulationsPresenter
    promotions?: CartPromotionPresenter[]
}
export type GetCartPresenter = {
    cart?: CartSummaryDto
}
export type CreateCartIdPresenter = {
    cartId?: string
}
export type CartItemCabanaDetailDto = {
    date?: string
    boxId?: string
}
export type CartItemParkingDetailDto = {
    from: string
    to: string
}
export type CreateCartItemCommand = {
    cartItemId: string
    productType:
        | 'ticket'
        | 'bus_ticket'
        | 'cabana'
        | 'accommodation'
        | 'shipping'
        | 'card'
        | 'bundle'
        | 'parking'
        | 'voucher'
        | 'product_voucher'
        | 'spa_treatment'
    productId: string
    quantity: number
    detail?:
        | (
              | CartItemTicketDetailDto
              | CartItemTransportTicketDetailDto
              | CartItemAccommodationDetailDto
              | CartItemCardDetailDto
              | CartItemCabanaDetailDto
              | CartItemParkingDetailDto
              | CartItemVoucherAmountDetailDto
              | CartItemVoucherProductDetailDto
              | CartItemSpaTreatmentDetailDto
              | CartItemVoucherNextVisitDetailDto
          )
        | null
    cartItemBundleId?: string
    date?: string
}
export type ListCartItemsPresenter = {
    items?: GetCartItemPresenter[]
}
export type CreateCartItemCommand2 = {
    cartItemId: string
    productType:
        | 'ticket'
        | 'bus_ticket'
        | 'cabana'
        | 'accommodation'
        | 'shipping'
        | 'card'
        | 'bundle'
        | 'parking'
        | 'voucher'
        | 'product_voucher'
        | 'spa_treatment'
    productId: string
    quantity: number
    detail?:
        | (
              | CartItemTicketDetailDto
              | CartItemTransportTicketDetailDto
              | CartItemAccommodationDetailDto
              | CartItemCardDetailDto
              | CartItemCabanaDetailDto
              | CartItemParkingDetailDto
              | CartItemVoucherAmountDetailDto
              | CartItemVoucherProductDetailDto
              | CartItemSpaTreatmentDetailDto
              | CartItemVoucherNextVisitDetailDto
          )
        | null
    cartItemBundleId?: string
    date?: string
}
export type CreateCartItemBundleCommand = {
    cartItemBundleId: string
    quantity: number
    productId: string
    items?: CreateCartItemCommand2[]
}
export type CreateCartItemsCommand = {
    items?: CreateCartItemCommand2[]
    itemsBundle?: CreateCartItemBundleCommand[]
}
export type DeleteCartItemsByIdCommand = {
    /** Cart item uuids */
    cartItemUuids: string[]
}
export type AddPromotionCouponCommand = {
    couponCode: string
}
export type GetAccommodationItemPresenter = {
    roomName?: string
    rateName?: string
    occupancyName?: string
    totalPrice?: number
}
export type ListAccommodationItemPresenter = {
    items?: GetAccommodationItemPresenter[]
}
export type CreateCartItemImageCommand = {
    /** Cart item uuid */
    cartItemId: string
    type: 'card'
    /** Image card file */
    image: Blob
}
export type BundleCartItemDto = {
    cartItemBundleId: string
    productId: string
    boxId: string
    date: string
}
export type CreateBundleCartItemsCommand = {
    bundles?: BundleCartItemDto[]
    cartCreatorType:
        | 'standard'
        | 'card'
        | 'accommodation'
        | 'card-renew'
        | 'voucher'
}
export type AddGiftCardCommand = {
    giftCardNumber: string
}
export type CreateContactCommand = {
    name: string
    surname: string
    email: string
    title:
        | 'subject_selfcare'
        | 'subject_complaints'
        | 'subject_general'
        | 'subject_group'
        | 'subject_accommodation'
        | 'subject_collaboration'
        | 'subject_media'
    phone?: string | null
    message: string
    lang: 'en' | 'pl' | 'uk'
}
export type CreateNewsletterCommand = {
    email: string
    mainConsent: boolean
    policyConsent: boolean
}
export type ReadPresenter = {
    isAccessibility?: boolean
}
export type ProductDayPriceDto = {
    price?: number
    date?: string
}
export type TicketInfoDto = {
    title?: string
    iconName?: ('drink' | 'palm') | null
    descriptionItems?: string[]
    description?: string
}
export type ProductStatusPresenter = {
    active?: boolean
    message?: string
}
export type TicketDto = {
    productId?: string
    time?: '2h' | '4h' | 'day'
    totalPrice?: number
    zone?: 'jamango' | 'relax' | 'saunaria'
    title?: string
    prices?: ProductDayPriceDto[]
    info?: TicketInfoDto[] | null
    status?: ProductStatusPresenter
}
export type ProductTranslationPresenter = {
    name?: string
    icon?: 'ticket' | 'ticket-2' | 'twoTickets' | 'restaurant'
    description?: string
}
export type ProductBadgePresenter = {
    name?: string
}
export type ProductBundlePresenter = {
    productId?: string
    name?: string
    unitPrice?: number
    descriptions?: ProductTranslationPresenter[]
    dates?: string[]
    status?: ProductStatusPresenter
    badge?: ProductBadgePresenter
}
export type ListTicketPresenter = {
    tickets?: TicketDto[]
    productBundles?: ProductBundlePresenter[]
}
export type PersonDto = {
    key?:
        | 'teen_reduced'
        | 'kid_to_120_cm'
        | 'teenager'
        | 'pregnant'
        | 'kid_to_90_cm'
        | 'senior'
        | 'disabled'
        | 'adult'
    title?: string
    description?: string | null
    displayName?: string | null
}
export type ListPresenter = {
    persons?: PersonDto[]
}
export type HighlightDto = {
    name?: string | null
    icon?: string | null
    message?: string | null
}
export type ZoneDto = {
    key?: 'jamango' | 'relax' | 'saunaria'
    title?: string
    highlight?: HighlightDto | null
}
export type ListZonePresenter = {
    zones?: ZoneDto[]
}
export type RouteTypeDto = {
    value?: string
    label?: string
}
export type ListPresenter2 = {
    types?: RouteTypeDto[]
}
export type DeparturePlaceDto = {
    value?: string
    label?: string
    description?: string
}
export type ListPresenter3 = {
    places?: DeparturePlaceDto[]
}
export type MapPoint = {
    latitude?: number
    longitude?: number
}
export type BusStopDto = {
    name?: string
    street?: string
    mapPoint?: MapPoint
}
export type HourDto = {
    time?: string
    isAvailable?: boolean
    available?: number | null
    description?: string | null
}
export type DestinationDto = {
    departureStop?: BusStopDto
    arrivalStop?: BusStopDto
    duration?: number
    isShuttle?: boolean
    isRequiresPurchaseTimeSlot?: boolean
    hours?: HourDto[]
}
export type BusSchedulePresenter = {
    productId?: string
    unitPrice?: number
    departureDestination?: DestinationDto
    returnDestination?: DestinationDto
    departureHours?: HourDto[]
    returnHours?: HourDto[]
}
export type GetProductPresenter = {
    productId?: string
    productType?: string
    name?: string
    unitPrice?: number
}
export type CardType = {
    value?: string
}
export type CardDetailDto = {
    name?: string
    cardType?: CardType
    editionType?: 'initial' | 'blue' | 'red'
    description?: string
    isRecommended?: boolean
}
export type ZoneType = {
    name?: string
    value?: string
}
export type CardOffer = {
    icon?: boolean
    name?: string
    description?: string
    showCalendar?: boolean
}
export type CardDto = {
    product?: GetProductPresenter
    detail?: CardDetailDto
    zones?: ZoneType[]
    offers?: CardOffer[]
}
export type ListCardPresenter = {
    cards?: CardDto[]
}
export type BundleItemDto = {
    productId?: string
    name?: string
    unitPrice?: number
    detail?: CardDetailDto
    zones?: ZoneType[]
    offers?: CardOffer[]
    productType?:
        | 'ticket'
        | 'voucher'
        | 'product_voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'accommodation'
        | 'shipping'
        | 'handling_fee'
        | 'card'
        | 'parking'
        | 'bundle'
        | 'restaurant_service'
        | 'spa_treatment'
}
export type CardBundleDto = {
    productId?: string
    productType?: string
    name?: string
    unitPrice?: number
    items?: BundleItemDto[]
}
export type ListCardBundlePresenter = {
    cards?: CardBundleDto[]
}
export type CardPersonDto = {
    key?: 'teen_reduced' | 'adult' | 'kid_to_120_cm' | 'discounted'
    title?: string
    description?: string | null
    displayName?: string | null
}
export type ListCardPersonPresenter = {
    persons?: CardPersonDto[]
}
export type GetCabanaLimitByDatePresenter = {
    limit?: number
}
export type ProductVoucherItemPresenter = {
    productId?: string
    name?: string
    unitPrice?: number
    productType?: string
    voucherType?: string
}
export type ProductVoucherPresenter = {
    name?: string
    productType?: string
    productId?: string
    unitPrice?: number
    voucheredProductId?: string
    items?: ProductVoucherItemPresenter[]
    voucherType?: string
}
export type ProductVouchersPresenter = {
    products?: ProductVoucherPresenter[]
}
export type SpaTreatmentVariantDto = {
    productSpaTreatmentId?: string
    name?: string
    price?: number
    duration?: number
}
export type ListItemSpaTreatmentPresenter = {
    spaTreatmentGroupId?: string
    name?: string
    description?: string
    imageUrl?: string
    categoryId?: string
    categoryName?: string
    variants?: SpaTreatmentVariantDto[]
    badge?: ProductBadgePresenter
}
export type ListSpaTreatmentPresenter = {
    items?: ListItemSpaTreatmentPresenter[]
}
export type GetSpaTreatmentPresenter = {
    name?: string
    longDescription?: string
    imageGalleryUrls?: string[]
    variants?: SpaTreatmentVariantDto[]
}
export type ListItemSpaTreatmentAvailableHourPresenter = {
    startDate?: string
    endDate?: string
    availablePlaces?: number
    isAvailable?: boolean
}
export type ListSpaTreatmentAvailableHourPresenter = {
    items?: ListItemSpaTreatmentAvailableHourPresenter[]
}
export type CreateOrderPresenter = {
    orderId?: string
    link?: string
}
export type OrderBillingDataForCompanyDto = {
    companyName: string
    nip: string
    street: string
    postCode: string
    city: string
    apartment?: string
}
export type OrderBillingDataForUserDto = {
    street: string
    postCode: string
    city: string
    apartment?: string
}
export type CreateOrderCommand = {
    name: string
    surname: string
    email: string
    confirmEmail: string
    hasRequiredAgreementsAccepted?: boolean
    optionalAgreements?: (
        | 'agreement.get_phone_offers'
        | 'agreement.get_email_offers'
        | 'agreement.get_email_partners_offers'
        | 'agreement.get_moyome_email_offers'
        | 'agreement.get_moyome_phone_offers'
        | 'agreement.get_moyome_partners_email_offers'
    )[]
    phone?: string | null
    orderBillingData?:
        | OrderBillingDataForCompanyDto
        | OrderBillingDataForUserDto
    userId?: string | null
}
export type GenerateOrderCommand = {
    paymentSystemId?: string
}
export type TransactionItemDto = {
    item_name?: string
    item_brand?: string
    item_variant?: string
    price?: number
    discount?: number
    quantity?: number
}
export type EcommerceDto = {
    transaction_id?: string
    value?: number
    tax?: number
    shipping?: number
    currency?: string
    coupon?: string
    items?: TransactionItemDto[]
}
export type ConfirmationPageEventDto = {
    event?: string
    ecommerce?: EcommerceDto
}
export type GetOrderAnalitycsPresenter = {
    orderId?: string
    cartId?: string
    productCount?: number
    orderTotal?: string
    cart?: CartSummaryDto
    confirmationPageEvent?: ConfirmationPageEventDto
}
export type AttractionsDto = {
    attractionKey?: string
    title?: string
    hours?: string[]
}
export type OpeningHoursDto = {
    title?: string
    isDefault?: boolean
    isSpecial?: boolean
    rows?: string[]
    attractions?: AttractionsDto[]
    /** Wyróżniony zakres godzin */
    isDefaultSpecial?: boolean
    sequence?: number
}
export type ListOpeningHoursItemsPresenter = {
    items?: OpeningHoursDto[]
}
export type ListProductPresenter = {
    items?: GetProductPresenter[]
}
export type ProductBundlesPresenter = {
    productBundles?: ProductBundlePresenter[]
}
export type AvailableOccupancyPresenter = {
    occupancyId?: string
    occupancyName?: string
    availability?: number
    price?: number
    totalPrice?: number
}
export type Badge = {
    text?: string
    textColor?: string
    backgroundColor?: string
}
export type AvailableRatePresenter = {
    rateId?: string
    rateName?: string
    occupancies?: AvailableOccupancyPresenter[]
    badges?: Badge[] | null
}
export type AvailableRoomPresenter = {
    roomId?: string
    productId?: string
    availproId?: string
    roomName?: string
    description?: string
    singleBedCount?: string
    doubleBedCount?: string
    sofaBedCount?: string
    pictures?: string[]
    rates?: AvailableRatePresenter[]
}
export type SearchRoomsPresenter = {
    list?: AvailableRoomPresenter[]
}
export type GetHotelPresenter = {
    id?: string
    name?: string
    description?: string
    address?: string
    postCode?: string
    city?: string
    longitude?: string
    latitude?: string
}
export type ListHotelsPresenter = {
    hotels?: GetHotelPresenter[]
}
export type GetRoomPresenter = {
    id?: string
    name?: string
    description?: string
    singleBedCount?: number
    doubleBedCount?: number
    sofaBedCount?: number
}
export type ListRoomsPresenter = {
    rooms?: GetRoomPresenter[]
}
export type GetOccupancyPresenter = {
    id?: string
    name?: string
    isDefault?: boolean
    personCount?: number
    adultCount?: number
    childCount?: number
    infantCount?: number
}
export type ListOccupanciesPresenter = {
    list?: GetOccupancyPresenter[]
}
export type ListOccupanciesByRoomPresenter = {
    list?: GetOccupancyPresenter[]
}
export type GetRatePresenter = {
    id?: string
    name?: string
    description?: string
    code?: string
}
export type ListRatesPresenter = {
    list?: GetRatePresenter[]
}
export type ListRatesByRoomPresenter = {
    list?: GetRatePresenter[]
}
export type ReservationRoomViewPresenter = {
    roomId?: string
    roomName?: string
    rateId?: string
    rateName?: string
    occupancyId?: string
    occupancyName?: string
    quantity?: number
    unitPrice?: number
    totalPrice?: number
}
export type GetReservationPresenter = {
    id?: string
    dateFrom?: string
    dateTo?: string
    adultCount?: number
    childCount?: number
    specialRequests?: string
    totalAmount?: number
    customerFirstName?: string
    customerLastName?: string
    customerEmail?: string
    status?: string
    rooms?: ReservationRoomViewPresenter[]
}
export type GetPromotionPresenter = {
    promotionName?: string
    isActive?: boolean
    startsAt?: string
    endsAt?: string
    productTypes?: string[]
}
export type PromotionConfirmationPresenter = {
    active?: boolean
    header?: string
    description?: string
    buttonApproveText?: string
    buttonDenyText?: string
}
export type PromotionPresenter = {
    confirmation?: PromotionConfirmationPresenter
}
export type CreateSelfcareSessionCommand = {
    type?: 'marchpromo'
    paymentNumber?: string
    email?: string
}
export type DateRangeDto = {
    from?: string
    to?: string
}
export type EditReservationTicketDetailDto = {
    orderTicketId?: string
    cartItemId?: string
    zone: 'jamango' | 'relax' | 'saunaria'
    person:
        | 'teen_reduced'
        | 'kid_to_120_cm'
        | 'teenager'
        | 'pregnant'
        | 'kid_to_90_cm'
        | 'senior'
        | 'disabled'
        | 'adult'
    ticketTime: '2h' | '4h' | 'day'
    day: string
    boxId?: string
}
export type EditReservationCabanaDetailDto = {
    orderCabanaId: string
    boxId: string
    date: string
}
export type EditReservationMemoryCaptureDetailDto = {
    orderMemoryCaptureId: string
}
export type EditReservationTransportDetailDto = {
    time: string | null
    returnDate: string
    returnTime: string | null
    isRequiresPurchaseTimeSlot?: boolean
    orderTransportTicketId: string
    routeType: 'to_from_park' | 'to_park' | 'from_park'
    departurePlace: 'warsaw' | 'zyrardow'
    date: string
    boxId: string
    isShuttle: boolean
}
export type EditReservationBundleDetailDto = {
    orderBundleId: string
    boxId: string
    date: string
}
export type EditReservationSpaTreatmentDetailDto = {
    orderSpaTreatmentId?: string
    variant: 20 | 25 | 30 | 45 | 50 | 60 | 90
    startDate: string
    endDate: string
}
export type ProductEditResponseDto = {
    price?: number
    quantity?: number
    detail?:
        | (
              | EditReservationTicketDetailDto
              | EditReservationCabanaDetailDto
              | EditReservationMemoryCaptureDetailDto
              | EditReservationTransportDetailDto
              | EditReservationBundleDetailDto
              | EditReservationSpaTreatmentDetailDto
          )
        | null
    name?: string
    descriptions?: ProductTranslationPresenter[]
}
export type ProductType = {
    type?: string
}
export type EditType = {
    value?: string
}
export type EditReservationDto = {
    changes?: ProductEditResponseDto | null
    isActive?: boolean
    productType?: ProductType | null
    changeType?: EditType | null
    original?: ProductEditResponseDto
    differencePrice?: number
    modificationId?: string
}
export type ListSelfcarePositionsPresenter = {
    reservationTime?: DateRangeDto[]
    orderId?: string
    cartId?: string
    positions?: EditReservationDto[]
    hasAccommodation?: boolean
    sessionType?: string
}
export type DeleteTicketDto = {
    orderTicketId: string
}
export type DeleteTransportTicketDto = {
    orderTransportTicketId: string
}
export type DeleteCabanaDto = {
    orderCabanaId: string
}
export type DeleteMemoryCaptureDto = {
    orderMemoryCaptureId: string
}
export type DeleteBundleDto = {
    orderBundleId: string
}
export type DeleteSpaTreatmentDto = {
    orderSpaTreatmentId: string
}
export type DeletePositionCommand = {
    productType:
        | 'ticket'
        | 'voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'shipping'
        | 'bundle'
        | 'spa_treatment'
    detail?:
        | (
              | DeleteTicketDto
              | DeleteTransportTicketDto
              | DeleteCabanaDto
              | DeleteMemoryCaptureDto
              | DeleteBundleDto
              | DeleteSpaTreatmentDto
          )
        | null
}
export type RevertPositionCommand = {
    modificationId: string
}
export type EditPositionCommand = {
    productType: 'ticket' | 'bus_ticket' | 'cabana' | 'bundle'
    detail:
        | (
              | EditReservationTicketDetailDto
              | EditReservationTransportDetailDto
              | EditReservationCabanaDetailDto
              | EditReservationBundleDetailDto
          )
        | null
}
export type RevertByProductTypeCommand = {
    productType:
        | 'ticket'
        | 'voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'shipping'
        | 'bundle'
        | 'spa_treatment'
}
export type SelfcarePositionNewPricePresenter = {
    currentPrice?: number
    newPrice?: number
    difference?: number
}
export type CartModificationItemTicketDetailDto = {
    orderTicketId: string
}
export type CartModificationItemTransportDetailDto = {
    orderTransportTicketId: string
}
export type CartModificationItemMemoryCaptureDetailDto = {
    orderMemoryCaptureId: string
}
export type CartModificationItemCabanaDetailDto = {
    orderCabanaId: string
}
export type SelfcarePositionNewPriceQuery = {
    productType:
        | 'ticket'
        | 'voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'shipping'
        | 'bundle'
        | 'spa_treatment'
    detail: CartItemTicketDetailDto | CartItemTransportTicketDetailDto
    cartModificationItemDetail:
        | CartModificationItemTicketDetailDto
        | CartModificationItemTransportDetailDto
        | CartModificationItemMemoryCaptureDetailDto
        | CartModificationItemCabanaDetailDto
}
export type CartSelfcarePriceSummaryDto = {
    beforeDiscountPrice?: number | null
    totalPrice?: number
    payOnlinePrice?: number
    refundPrice?: number
    countChanges?: number
    newItemsPrice?: number
    adjustmentPrice?: number
    payByCardPrice?: number
    remainingCardValue?: number
}
export type CartSelfcareSummaryDto = {
    cartId?: string
    newItemsQuantity?: number
    priceSummary?: CartSelfcarePriceSummaryDto
    items?: GetCartItemPresenter[]
    regulations?: GetCartRegulationsPresenter
    giftCards?: GiftCardDto[]
}
export type GetCartSelfcarePresenter = {
    cart?: CartSelfcareSummaryDto
}
export type CartItemVoucherDetailDto = {
    email?: string | null
    unitPrice?: number | null
    voucherType:
        | 'refund'
        | 'product'
        | 'amount'
        | 'unlimited-card'
        | 'next-visit'
    voucherSignature?: string[]
}
export type CreateCartItemSelfcareCommand = {
    cartItemId: string
    productType:
        | 'ticket'
        | 'voucher'
        | 'bus_ticket'
        | 'cabana'
        | 'memory_capture'
        | 'shipping'
        | 'bundle'
        | 'spa_treatment'
    productId?: string
    quantity: number
    detail?:
        | (
              | CartItemCabanaDetailDto
              | CartItemTransportTicketDetailDto
              | CartItemVoucherDetailDto
              | CartItemVoucherNextVisitDetailDto
          )
        | null
}
export type DeleteCartItemsByIdSelfcareCommand = {
    cartItemUuids: string[]
}
export type CreateSelfcareOrderCommand = {
    voucherSignature?: string[] | null
    optionalAgreements?: (
        | 'agreement.get_phone_offers'
        | 'agreement.get_email_offers'
        | 'agreement.get_email_partners_offers'
        | 'agreement.get_moyome_email_offers'
        | 'agreement.get_moyome_phone_offers'
        | 'agreement.get_moyome_partners_email_offers'
    )[]
}
export type GetShippingMethodPresenter = {
    name?: string
    code?: string
    deliveryType?: string
    price?: number
    productId?: string
}
export type GetShippingMethodsPresenter = {
    shippingMethods?: GetShippingMethodPresenter[]
}
export type AddShippingRequestDto = {
    deliveryType: 'shipping' | 'selfPickup' | 'email'
    shippingMethodCode: string
    email: string | null
    name: string | null
    surname: string | null
    street: string | null
    apartment?: string | null
    postCode: string | null
    city: string | null
    phone: string | null
}
export type AddShippingToCartCommand = {
    shippingData: AddShippingRequestDto
    cartId?: string
}
export type DeleteShippingFromCartCommand = {
    cartId?: string
}
export type EventPresenter = {
    dates?: string[]
    title?: string
    description?: string
    legendDescription?: string
    iconColor?: string
}
export type GetCalendarPresenter = {
    from?: string
    to?: string
    excluded?: string[]
    differentHours?: string[]
    differentPrices?: string[]
    events?: EventPresenter[]
}
export type ReadPresenter2 = {
    from?: string
    to?: string
    excluded?: string[]
    differentHours?: string[]
    differentPrices?: string[]
    events?: EventPresenter[]
}
export type ReadPresenter3 = {
    from?: string
    to?: string
    excluded?: string[]
}
export type ReadPresenter4 = {
    from?: string
    to?: string
    excluded?: string[]
}
export type GetCalendarPresenter2 = {
    from?: string
    to?: string
    excluded?: string[]
}
export type GetCardCalendarPresenter = {
    from?: string
    to?: string
    excluded?: string[]
    secondaryDays?: string[]
}
export type ContentDto = {
    title?: string
    subtitle?: string | null
    body?: string | null
}
export type ButtonDto = {
    text?: string
    url?: string
}
export type GetBannerTranslationPresenter = {
    bannerTranslationId?: string
    locale?: string
    content?: ContentDto
    desktopImageUrl?: string
    button?: ButtonDto
    mobileImageUrl?: string
}
export type GetBannerPresenter = {
    bannerId?: string
    position?: number
    translations?: GetBannerTranslationPresenter[]
}
export type GetBannerGroupPresenter = {
    type?: 'large' | 'small'
    banners?: GetBannerPresenter[]
}
export type ListBannerQueryPresenter = {
    bannerGroups?: GetBannerGroupPresenter[]
}
export type ContentHeroPresenter = {
    text?: string
}
export type ContentTopBarPresenter = {
    textDesktop?: string
    textMobile?: string
    url?: string
}
export type ContentPopupPresenter = {
    title?: string
    description?: string
    buttonText?: string
    buttonUrl?: string
}
export type HomepageContentPresenter = {
    hero?: ContentHeroPresenter
    topBar?: ContentTopBarPresenter
    popup?: ContentPopupPresenter
}
export type RegulationsPresenter = {
    items?: RegulationPresenter[]
}
export type RegulationCategoryPresenter = {
    name?: string
    regulations?: RegulationPresenter[]
}
export type RegulationCategoriesPresenter = {
    items?: RegulationCategoryPresenter[]
}
export type RegulationSectionPresenter = {
    name?: string
    slug?: string
    regulation?: RegulationPresenter
}
export type GetOrderPositionItemPresenter = {
    orderPositionItemId?: string
    name?: string
    serialNumber?: string
    productType?: string
    price?: string
    detail?:
        | CartItemTicketDetailDto
        | CartItemCabanaDetailDto
        | CartItemTransportTicketDetailDto
}
export type GetOrderItemPresenter = {
    orderId?: string
    createdAt?: string
    totalPrice?: string
    countProducts?: number
    positions?: GetOrderPositionItemPresenter[]
}
export type ListOrderPresenter = {
    items?: GetOrderItemPresenter[]
}
export type CreateOrderCardRenewSessionCommand = {
    token?: string
    password?: string
}
export type GetOrderCardRenewTokenPresenter = {
    orderCardRenewTokenId?: string
    used?: boolean
    expired?: boolean
    nextEditionType?: 'initial' | 'blue' | 'red'
}
export type GetCurrentOrderCardPresenter = {
    description?: string
    firstName?: string
    lastName?: string
    email?: string
    phoneNumber?: string
    cardType?: string
    person?: string
    dateOfBirth?: string
    expiryDateNewCard?: string
    currentEditionType?: 'initial' | 'blue' | 'red'
    nextEditionType?: 'initial' | 'blue' | 'red'
}
export type CartPresenter = {
    type?: 'creator' | 'selfcare'
    creatorType?:
        | 'accommodation'
        | 'standard'
        | 'card'
        | 'card-renew'
        | 'voucher'
    isShipping?: boolean
}
export type OrderPresenter = {
    id?: string
    email?: string
    cart?: CartPresenter
}
export type PaymentPresenter = {
    id?: string
    status?:
        | 'initiated'
        | 'pending'
        | 'completed'
        | 'cancelled'
        | 'expired'
        | 'rejected'
        | 'refunded'
    order?: OrderPresenter
}
export type GetVoucherQueryPresenter = {
    number?: string
    value?: number
    validFrom?: string | null
    validTo?: string | null
}
export type GetTrafficIndicatorPresenter = {
    jamango?: number
    relax?: number
    saunaria?: number
}
export const {
    useGetCartQuery,
    useLazyGetCartQuery,
    useCreateCartMutation,
    useDeleteCartMutation,
    useCreateCartItemMutation,
    useListCartItemsQuery,
    useLazyListCartItemsQuery,
    useCreateCartItemsMutation,
    useDeleteCartItemsByIdMutation,
    useGetCartItemQuery,
    useLazyGetCartItemQuery,
    useDeleteCartItemByIdMutation,
    useDeleteCartPromotionCouponMutation,
    usePatchCartPromotionCouponMutation,
    useGetCartItemAccommodationQuery,
    useLazyGetCartItemAccommodationQuery,
    useUploadCartItemCardImageMutation,
    useGetCartItemImageQuery,
    useLazyGetCartItemImageQuery,
    useDeleteCartItemImageMutation,
    useCreateBundleCartItemsMutation,
    usePatchCartGiftCardMutation,
    useDeleteCartGiftCardMutation,
    useContactAddMutation,
    useNewsletterAddMutation,
    useGetCreatorAccessibilityQuery,
    useLazyGetCreatorAccessibilityQuery,
    useListTicketPriceByTypesQuery,
    useLazyListTicketPriceByTypesQuery,
    useListTicketPersonsQuery,
    useLazyListTicketPersonsQuery,
    useListTicketZonesByPersonQuery,
    useLazyListTicketZonesByPersonQuery,
    useListTransportRouteTypesQuery,
    useLazyListTransportRouteTypesQuery,
    useListTransportDeparturePlacesQuery,
    useLazyListTransportDeparturePlacesQuery,
    useGetTransportSchedulesQuery,
    useLazyGetTransportSchedulesQuery,
    useListCreatorCardsQuery,
    useLazyListCreatorCardsQuery,
    useListCreatorCardsBundleQuery,
    useLazyListCreatorCardsBundleQuery,
    useListCreatorCardPersonsQuery,
    useLazyListCreatorCardPersonsQuery,
    useGetCreatorCabanaLimitByDateQuery,
    useLazyGetCreatorCabanaLimitByDateQuery,
    useListVouchersQuery,
    useLazyListVouchersQuery,
    useListCreatorSpaTreatmentsQuery,
    useLazyListCreatorSpaTreatmentsQuery,
    useGetCreatorSpaTreatmentGroupsQuery,
    useLazyGetCreatorSpaTreatmentGroupsQuery,
    useListCreatorSpaTreatmentsAvailableHourQuery,
    useLazyListCreatorSpaTreatmentsAvailableHourQuery,
    useCreateOrderMutation,
    useGenerateOrderQuery,
    useLazyGenerateOrderQuery,
    useGetOrderAnalitycsQuery,
    useLazyGetOrderAnalitycsQuery,
    useUpdateOrderCabanaUsedStatusGetQuery,
    useLazyUpdateOrderCabanaUsedStatusGetQuery,
    useUpdateOrderCabanaUsedStatusMutation,
    useListOpeningHoursQuery,
    useLazyListOpeningHoursQuery,
    useGetProductQuery,
    useLazyGetProductQuery,
    useListProductsQuery,
    useLazyListProductsQuery,
    useFindTicketProductBundlesQuery,
    useLazyFindTicketProductBundlesQuery,
    useAccommodationSearchAvailableRoomsQuery,
    useLazyAccommodationSearchAvailableRoomsQuery,
    useAccommodationGetHotelsQuery,
    useLazyAccommodationGetHotelsQuery,
    useAccommodationGetHotelQuery,
    useLazyAccommodationGetHotelQuery,
    useAccommodationGetRoomsQuery,
    useLazyAccommodationGetRoomsQuery,
    useAccommodationGetRoomQuery,
    useLazyAccommodationGetRoomQuery,
    useAccommodationGetRoomsByHotelIdQuery,
    useLazyAccommodationGetRoomsByHotelIdQuery,
    useAccommodationGetOccupanciesQuery,
    useLazyAccommodationGetOccupanciesQuery,
    useAccommodationGetOccupancyQuery,
    useLazyAccommodationGetOccupancyQuery,
    useAccommodationGetOccupanciesByRoomIdQuery,
    useLazyAccommodationGetOccupanciesByRoomIdQuery,
    useAccommodationGetRatesQuery,
    useLazyAccommodationGetRatesQuery,
    useAccommodationGetRateQuery,
    useLazyAccommodationGetRateQuery,
    useAccommodationGetRatesByRoomIdQuery,
    useLazyAccommodationGetRatesByRoomIdQuery,
    useAccommodationGetReservationQuery,
    useLazyAccommodationGetReservationQuery,
    useGetPromotionQuery,
    useLazyGetPromotionQuery,
    useFindPromotionByCouponCodeQuery,
    useLazyFindPromotionByCouponCodeQuery,
    useGuestLoginMutation,
    useListSelfcareOrderPositionsQuery,
    useLazyListSelfcareOrderPositionsQuery,
    useDeleteSelfcareOrderPositionsMutation,
    useDeleteSelfcareOrderPositionMutation,
    useRevertSelfcareOrderPositionMutation,
    useEditSelfcareOrderPositionMutation,
    useRevertChangeByProductTypeMutation,
    useRevertChangesMutation,
    useGetSelfcareAttachmentQuery,
    useLazyGetSelfcareAttachmentQuery,
    useGetSelfcareOrderPositionPriceMutation,
    useGetSelfcareCartQuery,
    useLazyGetSelfcareCartQuery,
    useCreateSelfcareCartItemMutation,
    useDeleteSelfcareCartItemByIdMutation,
    useDeleteSelfcareCartItemsByIdMutation,
    useCreateSelfcareOrderMutation,
    useGetShippingMethodsQuery,
    useLazyGetShippingMethodsQuery,
    useAddShippingToCartPutMutation,
    useAddShippingToCartMutation,
    useDeleteShippingToCartMutation,
    useGetCalendarByProductTypeQuery,
    useLazyGetCalendarByProductTypeQuery,
    useListTicketAvailableDaysQuery,
    useLazyListTicketAvailableDaysQuery,
    useListAccommodationAvailableDaysQuery,
    useLazyListAccommodationAvailableDaysQuery,
    useGetTransportAvailableDaysQuery,
    useLazyGetTransportAvailableDaysQuery,
    useGetSelfcareCalendarQuery,
    useLazyGetSelfcareCalendarQuery,
    useGetCardCalendarQuery,
    useLazyGetCardCalendarQuery,
    useListBannersQuery,
    useLazyListBannersQuery,
    useHomepageContentQuery,
    useLazyHomepageContentQuery,
    useFindRegulationsQuery,
    useLazyFindRegulationsQuery,
    useFindRegulationCategoriesQuery,
    useLazyFindRegulationCategoriesQuery,
    useFindRegulationSectionsQuery,
    useLazyFindRegulationSectionsQuery,
    useFindRegulationSectionBySlugQuery,
    useLazyFindRegulationSectionBySlugQuery,
    useGetFindRegulationDocumentByIdQuery,
    useLazyGetFindRegulationDocumentByIdQuery,
    useListUserOrderQuery,
    useLazyListUserOrderQuery,
    useGetUserOrderQuery,
    useLazyGetUserOrderQuery,
    useCreateOrderCardRenewSessionMutation,
    useGetOrderCardRenewTokenQuery,
    useLazyGetOrderCardRenewTokenQuery,
    useGetCurrentOrderCardQuery,
    useLazyGetCurrentOrderCardQuery,
    usePostNotificationMutation,
    usePostNotificationMoyomeMutation,
    useFindPaymentByIdQuery,
    useLazyFindPaymentByIdQuery,
    useGetVoucherQuery,
    useLazyGetVoucherQuery,
    useGetTrafficQuery,
    useLazyGetTrafficQuery,
    useGetDeprecatedUserRegisterConfirmQuery,
    useLazyGetDeprecatedUserRegisterConfirmQuery,
    useGetHealthCheckRedisQuery,
    useLazyGetHealthCheckRedisQuery,
    useGetHealthCheckDatabaseQuery,
    useLazyGetHealthCheckDatabaseQuery,
    useGetHealthCheckReadinessQuery,
    useLazyGetHealthCheckReadinessQuery,
    useGetHealthCheckLivenessQuery,
    useLazyGetHealthCheckLivenessQuery,
    usePushMessageQuery,
    useLazyPushMessageQuery,
} = injectedRtkApi
